module.exports = __webpack_public_path__ + "distretto-news-large.jpg?e27c853f41e328908d839d52adbbc8aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/distretto-news-large.jpg
// module id = 172
// module chunks = 0